import React, { useState } from 'react';
import { SparklesIcon } from '@heroicons/react/outline';
import Button, { ButtonColors } from '../../../common/Button';
import { Checkbox } from '../../../common/form/Checkbox';
import Modal, { ModalSizes } from '../../../common/Modal';
import { OpenClosedStates } from '../../../common/OpenClosedStates';

type Props = {
	state: OpenClosedStates;
	onClose: () => void;
	onOptimize: (optimizeTitle: boolean, optimizeDescription: boolean) => void;
	currentTitle: string;
	currentDescription: string;
	isOptimizing: boolean;
};

const OptimizeModal: React.FC<Props> = ({
	state,
	onClose,
	onOptimize,
	currentTitle,
	currentDescription,
	isOptimizing,
}) => {
	const [optimizeTitle, setOptimizeTitle] = useState(false);
	const [optimizeDescription, setOptimizeDescription] = useState(false);
	
	const handleClose = () => {
		setOptimizeTitle(false);
		setOptimizeDescription(false);
		onClose();
	};

	const handleOptimize = () => {
		onOptimize(optimizeTitle, optimizeDescription);
	};

	return (
		<Modal state={state} size={ModalSizes['md']} noScroll>
			<div>
				<div className="text-left">
					<h3 className="text-lg leading-6 font-medium text-gray-900 mb-2 flex items-center">
						<SparklesIcon className="h-5 w-5 mr-2 text-gray-600" />
						Optimize with Shed-telligence
					</h3>
					<p className="text-sm text-gray-500 mb-6">
						Select the fields you want to improve.
					</p>
				</div>
				
				<div className="space-y-4">
					<div className="border border-gray-200 rounded-lg p-4">
						<div className="flex items-center mb-2">
							<Checkbox
								name="optimizeTitle"
								label="Product Title"
								value={optimizeTitle}
								onChange={setOptimizeTitle}
								className="!mb-0"
							/>
						</div>
						<div className="bg-gray-50 p-3 rounded-md text-sm text-gray-700">
							{currentTitle || 'No title set'}
						</div>
					</div>
					
					<div className="border border-gray-200 rounded-lg p-4">
						<div className="flex items-center mb-2">
							<Checkbox
								name="optimizeDescription"
								label="Product Description"
								value={optimizeDescription}
								onChange={setOptimizeDescription}
								className="!mb-0"
							/>
						</div>
						<div className="bg-gray-50 p-3 rounded-md text-sm text-gray-700">
							{currentDescription ? 
								currentDescription.length > 150 
									? `${currentDescription.substring(0, 150)}...` 
									: currentDescription
								: 'No description set'
							}
						</div>
					</div>
				</div>
				
				<div className="mt-6 flex justify-end space-x-3">
					<Button
						text="Cancel"
						onClick={handleClose}
						color={ButtonColors.transparent}
					/>
					<Button
						text="Optimize"
						onClick={handleOptimize}
						color={ButtonColors.primary}
						loading={isOptimizing}
						disabled={!optimizeTitle && !optimizeDescription}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default OptimizeModal;